import {
  QueryClient,
  useQuery,
  useQueryClient
} from '@tanstack/react-query';
import axios from 'axios';
import { ApiResponse } from 'src/constants/apiResponse';
import { LicenseEntity } from 'src/entities/licenseEntity';

const getCompany = (queryClient: QueryClient, companyId: number) => async () => {
  if (!companyId) return null;

  const requestPath = `/api/v2/company/?company_id=${companyId}`;
  const res = await axios.get<ApiResponse>(requestPath);
  // const entity = JSON.parse(res.data as unknown as string) as LicenseEntity;
  const entity = res.data as unknown as LicenseEntity;
  return entity;
};

/**
 * 会社設定のクエリキーの先頭。#329
 *
 * 無効化は前方一致（`['company']`）で当てるので、ここと無効化側が同じ文字列である必要がある。
 * 両側にリテラルを書くと、片方を変えても誰も落ちないまま無効化だけが当たらなくなる。
 */
export const COMPANY_QUERY_KEY = 'company';

export const useQueryCompany = (companyId: number) => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: [COMPANY_QUERY_KEY, { companyId }],
    queryFn: getCompany(queryClient, companyId),
    enabled: !!companyId && companyId > 0,
    staleTime: Infinity,
  });
};
